import { el, mount, unmount } from 'redom';

import serverInterface from 'server-interface';

import { stringToSVG } from 'utilities';
import { preventPropogation } from 'utilities/dom';

import Tooltip from './tooltip';

import microphoneInactiveIconString from 'assets/images/meeting-microphone-inactive-icon.svg?raw';
import microphoneActiveIconString from 'assets/images/meeting-microphone-active-icon.svg?raw';

const microphoneInactiveIcon = stringToSVG(microphoneInactiveIconString);
const microphoneActiveIcon = stringToSVG(microphoneActiveIconString);

class MeetingAudioControls {

  constructor(meeting) {

    this.meeting = meeting;

    this.muted = this.meeting.muteAll;

    this.muteButton = el('button.meeting-audio-mute-button.meeting-room-control', [microphoneInactiveIcon.cloneNode(true)]);
    this.unmuteButton = el('button.meeting-audio-unmute-button.meeting-room-control', {}, [microphoneActiveIcon.cloneNode(true)]);

    this.muteButtonWithTooltip = new Tooltip(this.muteButton, '.mute-button-tooltip', 'Mute all');
    this.unmuteButtonWithTooltip = new Tooltip(this.unmuteButton, '.unmute-button-tooltip', 'Unmute all');

    this.el = el('.screen-audio-controls-main');

    if (this.muted === true) {
      this.mountUnmuteButton();
    } else {
      this.mountMuteButton();
    }

  }

  onmount() {

    this.registerEventListeners();

  }

  onunmount() {

  }

  registerEventListeners() {

    this.muteButton.addEventListener('click', this.mute.bind(this));
    this.muteButton.addEventListener('dblclick', preventPropogation);

    this.unmuteButton.addEventListener('click', this.unmute.bind(this));
    this.unmuteButton.addEventListener('dblclick', preventPropogation);

  }

  mountMuteButton() {

    mount(this.el, this.muteButtonWithTooltip);

  }

  unmountMuteButton() {

    unmount(this.el, this.muteButtonWithTooltip);

  }

  mountUnmuteButton() {

    mount(this.el, this.unmuteButtonWithTooltip);

  }

  unmountUnmuteButton() {

    unmount(this.el, this.unmuteButtonWithTooltip);

  }

  async doMute() {

    const postId = this.meeting.postId;

    await serverInterface.startup.community.singleProducerMeeting.muteSingleProducerMeetingByPostId(postId);

    this.unmountMuteButton();
    this.mountUnmuteButton();

  }

  async mute(event) {

    event.stopPropagation();

    this.doMute();

  }

  async doUnmute() {

    const postId = this.meeting.postId;

    await serverInterface.startup.community.singleProducerMeeting.unmuteSingleProducerMeetingByPostId(postId);

    this.unmountUnmuteButton();
    this.mountMuteButton();

  }

  async unmute(event) {

    event.stopPropagation();

    this.doUnmute();

  }

}

export default MeetingAudioControls;